import React from 'react';

const markup = String.raw`<div class="inline-style-41" id="vendFilterBar">
<span class="inline-style-42">Active filters:</span>
<span class="inline-style-43" id="vendFilterChips"></span>
<span class="reset-tag" onclick="vendResetAll()">Reset filters ↺</span>
</div>`;

export default function VendorFilterBar() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
